import { numberToLocale } from '../../utils/translate';
import i18n from 'i18next';

export function getInt(number?: number) {
  return numberToLocale(number).split(',')[0];
}

export function getDecimal(number?: number) {
  const decimal = numberToLocale(number).split(',')[1];
  if (decimal) {
    return `,${decimal}`;
  }

  return ',00';
}

export function getIntAndDecimal(number?: number, symbol: ',' | '.' = ',') {
  if (!number) return '';
  return `${getInt(number)}${getDecimal(number)}`.replace(',', symbol);
}

export function getAmountHelperText({
  isOverdue = false,
  is7CONS,
  getNextPaymentDueDate,
}: {
  isOverdue?: boolean;
  is7CONS: boolean;
  getNextPaymentDueDate: () => string | undefined;
}) {
  if (isOverdue) {
    return i18n.t('active_loan:schedule_amount_info', {
      date: getNextPaymentDueDate(),
    });
  } else if (!is7CONS) {
    return i18n.t('active_loan:amount_info');
  }
}
